<template>
  <div class="ai-v1-turn">
    <tracey-ai-message-row
      :message="{ role: 'user', content: message.userInput, createdAt: message.createdAt }"
      :is-query-data-present="() => false"
      :format-timestamp="formatTimestamp"
    />
    <tracey-ai-message-row
      v-if="message.response"
      :message="{ role: 'assistant', content: message.response, createdAt: message.createdAt, querystring: message.querystring, version: 'v1' }"
      :is-query-data-present="isQueryDataPresent"
      :format-timestamp="formatTimestamp"
      @view-data="$emit('view-data', message)"
    />
  </div>
</template>

<script>
import TraceyAiMessageRow from './TraceyAiMessageRow.vue';

export default {
  name: 'TraceyAiV1Turn',
  components: { TraceyAiMessageRow },
  props: {
    message: { type: Object, required: true },
    isQueryDataPresent: { type: Function, required: true },
    formatTimestamp: { type: Function, required: true },
  },
};
</script>
